export default "__VITE_ASSET__DAz557ws__";